import vueApp from '@/store';
import { fexeriaWsUrl, HostError } from '../helpers/host';
import { targetContext } from './fexeriaHttp';

// Avisos en vivo: wss://<host de la empresa>/ws/fexeria/ (un socket por pestaña; se reabre al cambiar de empresa).
// La URL va sin parámetros: lo primero que se envía es {type:'auth', token, company_id?} (el token nunca va
// en la URL). Solo se procesan los mensajes type === 'event'. Si se cierra, reconecta con backoff y vuelve a
// pedir lo que está en pantalla; no reintenta ante 4401/4403/4404.

const DEBUG = process.env.VUE_APP_FEXERIA_DEBUG === 'true';
const BACKOFF_START_MS = 1000;
const BACKOFF_MAX_MS = 30000;
const NO_RETRY_CODES = [4401, 4403, 4404];

let socket = null;
let session = 0; // ignora eventos de sockets ya reemplazados
let retryTimer = null;

export function closeFexeriaSocket() {
  session += 1;
  clearTimeout(retryTimer);
  if (socket) {
    socket.onopen = null;
    socket.onclose = null;
    socket.onmessage = null;
    try {
      socket.close();
    } catch (e) {
      // ya cerrado
    }
    socket = null;
  }
}

export function openFexeriaSocket(onEvent, onResync = () => {}, attempt = 0) {
  closeFexeriaSocket();
  const mine = session;
  const ctx = targetContext();
  let url;
  try {
    url = fexeriaWsUrl(ctx);
  } catch (e) {
    if (e instanceof HostError) console.error('[fexeria] socket no abierto: host no válido', e.host);
    return;
  }
  const token = vueApp.state.auth_store.userInfo?.Token;
  if (!token) return;

  if (DEBUG) console.debug('[fexeria] socket abriendo →', url, ctx.isSuper ? '(admin SipMóvil)' : '');
  const ws = new WebSocket(url);
  socket = ws;

  ws.onopen = () => {
    if (mine !== session) return;
    const auth = { type: 'auth', token };
    if (ctx.isSuper && ctx.company?.id) auth.company_id = ctx.company.id;
    ws.send(JSON.stringify(auth));
  };

  ws.onmessage = (event) => {
    if (mine !== session) return;
    let msg = null;
    try {
      msg = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    if (msg?.type === 'event') {
      if (DEBUG) console.debug('[fexeria] evento', msg.event, msg.action, msg.module || '');
      onEvent(msg);
    } else if (msg?.type === 'ready') {
      if (DEBUG) console.debug('[fexeria] socket listo', msg.role, 'empresa', msg.company_id);
      const reconnected = attempt > 0;
      attempt = 0;
      if (reconnected) onResync();
    } else if (msg?.type === 'error') {
      console.warn('[fexeria] socket error', msg.code);
    }
  };

  ws.onclose = (e) => {
    if (mine !== session) return;
    if (NO_RETRY_CODES.includes(e?.code)) {
      console.warn('[fexeria] socket cerrado sin reintento, código', e.code);
      return;
    }
    const delay = Math.min(BACKOFF_START_MS * 2 ** attempt, BACKOFF_MAX_MS);
    retryTimer = setTimeout(() => {
      if (mine === session) openFexeriaSocket(onEvent, onResync, attempt + 1);
    }, delay);
  };
}
